import { FETCH_SITE_CONFIG } from './types'
import { objectReducer } from 'utils'
import styles from 'mocks/themes'

const initialState = {
  supportedLanguages: [],
  factoryNetworkLink: null, // Dating Factory - not used
  siteId: null,
  siteName: null,
  styles,
  isUsa: false,
}

const config = objectReducer(FETCH_SITE_CONFIG, initialState, {
  success: data => {
    sessionStorage.siteStyles = JSON.stringify(data.styles || styles)
    if (!data.styles) {
      console.warn('STYLES CONFIG EMPTY IN `/api/site.json` - falling back to default styles')
      data.styles = styles
    } else {
      sessionStorage.theme && Object.assign(data.styles, styles)
      data.styles.roundness = /^(nooky|purple)buddies|localhost/.test(location.host) ? 1 : data.styles.roundness
    }
    data.supportedLanguages = data.supportedLanguages.filter(e => e.id != 36) // remove EN-US
    return data
  },
  extra: (state, { type, payload }) => {
    if (type == 'CHANGE_THEME') {
      return { ...state, styles: Object.assign({}, state.styles, payload) }
    }
    if (type == 'CHANGE_COLOR') {
      return { ...state, styles: { ...state.styles, colors: { ...state.styles.colors, ...payload } } }
    }
    return state
  },
})

export default config
